import { useEffect } from 'react';
import { IDLE_LOGOUT_EVENT } from '../../auth/idleLogoutEvents';
import { useSession } from '../../contexts/SessionContext';
import { useFormData } from '../../contexts/FormDataContext';
import { useTranscript } from '../../contexts/TranscriptContext';
import { useAmbientListening } from '../../contexts/AmbientListeningContext';

const WORKFLOW_FORM_TABS = [
  'Registration',
  'PreConsultation',
  'Consultation',
  'Prescription',
  'Billing',
] as const;

/**
 * On idle logout, clear visit + in-memory form state without saving (TC-AUT-003).
 */
export default function IdleLogoutCleanup() {
  const { clearSession } = useSession();
  const { clearFormForTab } = useFormData();
  const { clearTranscripts } = useTranscript();
  const { stopListening } = useAmbientListening();

  useEffect(() => {
    const onIdleLogout = () => {
      try {
        stopListening();
      } catch {
        // ignore
      }
      clearTranscripts();
      for (const tab of WORKFLOW_FORM_TABS) {
        clearFormForTab(tab);
      }
      clearSession();
      try {
        delete (window as { __whisperLiveKitData?: unknown }).__whisperLiveKitData;
      } catch {
        // ignore
      }
    };

    window.addEventListener(IDLE_LOGOUT_EVENT, onIdleLogout);
    return () => window.removeEventListener(IDLE_LOGOUT_EVENT, onIdleLogout);
  }, [clearSession, clearFormForTab, clearTranscripts, stopListening]);

  return null;
}
